<template>
  <div v-if="renderedDescription" class="description dynamic-content" v-html="renderedDescription"></div>
</template>
<script>
import { computed } from 'vue'
import { normalizeRichHtml } from '~/lib/rich-html'

export default {
  props: {
    description: {
      required: false,
      default: null
    }
  },
  setup (props) {
    const renderedDescription = computed(() => normalizeRichHtml(props.description))

    return {
      renderedDescription
    }
  }
}
</script>
